export default "__VITE_ASSET__D2GI_SZh__"